  <template>
  <v-card class="d-flex" color="secondary">
    <v-card-title
      ><span class="title-style">Detalhes do usuário</span></v-card-title
    >
    <v-divider style="padding: 24px 0px 0px"></v-divider>
    <v-card-text>
      <div>
        <span class="pt-5 subtitle-style">DADOS</span>
      </div>
      <div class="pt-5">
        <label class="label-style" for="name">Nome</label>
        <p class="description-style pt-1">{{ user.name }}</p>
      </div>
      <div>
        <label class="label-style" for="email">E-mail</label>
        <p class="description-style pt-1">{{ user.email }}</p>
      </div>
      <div>
        <label class="label-style" for="sector">Setor</label>
        <p class="description-style pt-1">{{ departamentFilter(user) }}</p>
      </div>
      <div>
        <label class="label-style" for="status">Último acesso</label>
        <p class="description-style pt-1">
          {{ lastAccessAt(user.lastAccessAt) }}
        </p>
      </div>
      <div>
        <label class="label-style" for="name">Status</label>
        <p class="description-style pt-1">
          {{ user.active ? "Ativo" : "Inativo" }}
        </p>
      </div>
      <div>
        <label class="label-style" for="perfil">Perfil</label>
        <p class="description-style pt-1">
          {{ user.admin ? "Administrador" : "Usuário" }}
        </p>
      </div>

      <div class="pt-5">
        <span class="pt-5 subtitle-style">ÚLTIMA ALTERAÇÃO</span>
      </div>
      <div class="pt-4">
        <label class="label-style" for="date">Data</label>
        <p class="description-style pt-1">{{ date }}</p>
      </div>
      <div>
        <label class="label-style" for="name">Por</label>
        <p class="description-style pt-1">{{userGranted}}</p>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="accent" outlined id="btn-close" @click="close(false)">
        <span>Fechar </span>
      </v-btn>
      <a @click="openEdit(false)" class="pl-5 label-edit-style"
        >Editar usuário</a
      >
    </v-card-actions>
  </v-card>
</template> 

<script>
//import UserSevice from "@/api/rest-administrative/user.service";
export default {
  name: "DialogUserDetalis",
  props: {
    user: {
      type: Object,
      required: true,
    },
    departaments: {
      type: Array,
      required: true,
      default: () => [],
    },

    date: {
      type: String,
      required: true,
    },
    userGranted: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    departament: null,
    dataAndTime: null,
  }),

  methods: {
    close(dialog) {
      this.$emit("setDialog", dialog, this.user);
    },

    openEdit(dialog) {
      this.$emit("docStates", "edit", this.user, dialog);
    },
    departamentFilter(item) {
      const departament = this.departaments.find(
        (element) => element.id === item.departmentId
      );

      return departament.name;
    },
    lastAccessAt(dateTime) {
      if (dateTime) {
        const dateAndTime = new Date(dateTime);
        let today = new Date();
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const yyyy = today.getFullYear();
        today = dd + "/" + mm + "/" + yyyy;
        const date = `${String(dateAndTime.getDate()).padStart(
          2,
          "0"
        )}/${String(dateAndTime.getMonth() + 1).padStart(
          2,
          "0"
        )}/${dateAndTime.getFullYear()}`;

        const hours = `${dateAndTime.getHours()}:${dateAndTime.getMinutes()}`;
        if (today == date) {
          const t = new Date();
          const diferenca = new Date(dateAndTime - t);
          let resultado = diferenca.getUTCHours();

          if (resultado == 24) {
            return "Online agora";
          }
          if (resultado == 23) {
            return `${60 - diferenca.getMinutes()}m atrás`;
          }

          return `${23 - resultado}h atrás`;
        }

        return `${date} ás ${hours}`;
      }

      return "";
    },

    /*    async searchLastChange() {
      const response = await UserSevice.getUser(this.user.id);  
      //this.userGranted =  await  UserSevice.getUser(response.data.userGranted)
    
   //   const dataTime = new Data(response.data.)
      
      
    }, */
  },
};
</script>


<style scoped>
.title-style {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 27px;
  color: var(--v-primary);
}
.subtitle-style {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-base);
}

.label-style {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: var(--v-primary-darken1);
  letter-spacing: 0.75px;
}

.description-style {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
  height: 18px;
}
.label-edit-style {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: #f99741;
  color: var(--v-accent-lighten1);
  height: 18px;
}

#btn-close {
  text-transform: none;
  border-radius: 8px;
  width: 87px;
  height: 50px;
  box-shadow: 0px 2px 4px rgba(56, 65, 80, 0.25);
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
}
</style>  